import styled from "styled-components";
import { setFontVariant, colorsPalettes } from "@similarweb/styles";
import { FlexColumn, FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import { IconButton } from "@similarweb/ui-components";

export const Container = styled(FlexColumn)`
    margin-top: 16px;
`;

export const TitleContainer = styled(FlexRow)`
    align-items: center;
    cursor: pointer;
`;

export const Title = styled.div`
    ${setFontVariant("listItem1", colorsPalettes.carbon[500])};
`;

export const StyledIconButton = styled(IconButton)`
    svg path {
        fill: ${colorsPalettes.carbon[400]};
    }
`;

export const CardsContainer = styled(FlexRow)<{ isOpen: boolean }>`
    gap: 16px;
    overflow: hidden;
    transition:
        height,
        0.5s ease-in-out;
    height: ${({ isOpen }) => (isOpen ? "72px" : "0")};
    margin-top: ${({ isOpen }) => isOpen && "18px"};
`;
